import { Field, makeStyles, SpinButton, tokens } from '@fluentui/react-components';
import { useT } from '@powerportalspro/react';
import { Timeline } from '@powerportalspro/react-fluent';
import { useState } from 'react';

// Reuses the Blazor demo's `TimelineUpcomingDemo` keys so both stacks read from the same JSON.
const STRINGS_BASE = 'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Timelines.TimelineUpcomingDemo';

const TABLES = ['annotation', 'ppp_portalcommunication', 'appointment', 'task', 'phonecall'];

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },
  field: {
    alignSelf: 'flex-start',
    gridTemplateColumns: 'auto auto',
    '& label': {
      whiteSpace: 'nowrap',
    },
  },
  days: {
    width: '85px',
  },
});

// The page's account's next few days above its history: its meetings, calls and tasks beside its
// notes and messages, with how many days ahead it looks for the reader to change.
export function TimelineUpcomingSample() {
  const styles = useStyles();
  const t = useT();
  const [days, setDays] = useState(3);

  return (
    <div className={styles.root}>
      <Field label={t(`${STRINGS_BASE}.days`)} orientation="horizontal" className={styles.field}>
        <SpinButton
          className={styles.days}
          min={1}
          max={365}
          value={days}
          onChange={(_, d) => {
            const n = typeof d.value === 'number' ? d.value : Number(d.displayValue);
            if (Number.isFinite(n)) setDays(Math.min(365, Math.max(1, Math.round(n))));
          }}
        />
      </Field>
      <Timeline upcoming={{ days }} defaultTables={TABLES} pageSize={8} maxHeight="560px" />
    </div>
  );
}
